import { BaseEntity } from "yt-ng-framework";

export class EOtpremnicaStavkaView extends BaseEntity{
    constructor(){
        super();
    }

    RedniBroj:number;
    Roba: string;
    Kolicina: number;
    JedinicaMere: string; 
    RobaID: number;
    Sifra: string;

    Deserialize(input:any){
        this.ID=input.ID;
        this.RedniBroj=input.RedniBroj;
        this.Roba=input.Roba;
        this.Kolicina = input.Kolicina;
        this.JedinicaMere = input.JedinicaMere;
        this.RobaID=input.RobaID;
        this.Sifra=input.Sifra;

        return this;
    }

    Serialize(input:EOtpremnicaStavkaView){
        return input;
    }
}